import axios from 'axios';
import apiRecordLayoutFunctions, { task_complete } from '../helpers/apiRecordLayoutFunctions.js';
import Metadata from '../helpers/metadata/Metadata';
import recordDescriptorProcessing  from '../helpers/StoreFunctions/recordDescriptorProcessing';
import serviceUtil from './serviceUtil';
import DataModel from '../models/DataModel.js';

let helpers = {
  getTasks() {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/tasks?current_company=' + localStorage.current_company_id,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error =>{
      return { error: error };
    });
  },
  getTask(taskId, options) {
    let filter = task_complete;
    let encodedFilter = '';
    if (options && options.recordDescriptor) {
      //added this for now so we can descriminate between old and new calls
      encodedFilter = recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    else {
      if (options && options.filter) {
        filter = options.filter;
      } 
      encodedFilter = apiRecordLayoutFunctions.getEncodedRecordLayout(filter);
    }
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/tasks/' + taskId + '?current_company=' + localStorage.current_company_id +
        '&filtering=' + encodedFilter,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  getTasksByIds(taskIds, options) {
    let request =  process.env.REACT_APP_API + '/tasks?current_company=' + localStorage.current_company_id; 
    
    if (options && options.recordDescriptor) {
      //added this for now so we can descriminate between old and new calls
      request += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    request += taskIds ? '&task_ids=' + taskIds.join() : '';

    return axios({
      method: 'get',
      url: request,
      timeout: 20000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  getMyTasks(statusFilter, activeOnly, companyId, project_id, page, perPage, showArchived, options = {}, filters) {
    let request = `${process.env.REACT_APP_API}/tasks?current_company=${(companyId ? companyId : localStorage.current_company_id)}` +
      (project_id ? `&project=${project_id}` : '') + (statusFilter ? `&status=${statusFilter}` : '') + (activeOnly ? '&active=true' : '') +
      (perPage ? (page ? '&page=' + page + '&per=' + perPage : '') : '') + '&order=project_name,asc' + (showArchived ? '&archived=true' : '');
    if (options && options.recordDescriptor) {
      request += '&filtering=' +recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor); 
    }

    filters = filters || {};
    request += (filters.user ? '&user_id=' + filters.user.id : ''); 

    return axios({
      method: 'get',
      url: request,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  createTask(task, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const build_id = task.build ? task.build.id : task.build_id;
    delete task.build_id;
    delete task.build;
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/tasks/?build=' + build_id + '&current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        task: task,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return { error: error };
    });
  },
  updateTask(task, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    task.location_id = task.location ? task.location.id : task.location_id;
    task.project = null;
    task.parent = null;
    delete task.project;
    delete task.location;
    delete task.tasks;
    delete task.ancestry;
    delete task.completion_percentage;
    delete task.tasks_count;
    delete task.builds_count;
    delete task.created_by;
    delete task.attachments;
    delete task.custom_task_settings;
    delete task.comments;
    delete task.completion_criteria;
    delete task.parent;
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/tasks/' + task.id + '?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        task: task,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return {};
    });
  },
  copyTask(task, build_id, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/tasks/' + task.id + '/copy_task?build=' + build_id + '&current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        task: task,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });

  },
  updateTaskDependencies(task, task_dependent_on, options) {
    const eventMetadatum = Metadata.generateMetadatum();
    delete task.user_task_assignments;
    delete task.task_dependencies;
    delete task_dependent_on.task_dependencies;
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/tasks/' + task.id + '/update_task_dependencies?current_company=' + localStorage.current_company_id + (
        options && options.recordDescriptor ? '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor) : ''),
      data: {
        event_metadatum: eventMetadatum,
        task: task,
        task_dependent_on_id: task_dependent_on.id,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return { error: error };
    });
  },
  updateTaskAssignments(task, assignmentList, options) {
    const eventMetadatum = Metadata.generateMetadatum();
    delete task.user_task_assignments;
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/tasks/' + task.id + '/update_task_assignments?current_company=' + localStorage.current_company_id + (
        options && options.recordDescriptor ? '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor) : ''),
      data: {
        event_metadatum: eventMetadatum,
        task: task,
        assignment_list: assignmentList,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return { error: error };
    });
  },
  bulkAssign(bulkAssign) {
    const eventMetadatum = Metadata.generateMetadatum();
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/tasks/bulk_assign?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        bulk_assign: bulkAssign,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return { error: error };
    });
  },
  deleteTask(task_id, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/tasks/' + task_id + '?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return { status: 'success' };
    })
      .catch(error => {
        return {};
      });
  },
  addReferenceDocument(taskId, referenceDocumentId, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/tasks/' + taskId + '/add_reference_document?reference_document_id=' + referenceDocumentId + '&current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  deleteReferenceDocument(taskId, referenceDocumentId, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/tasks/' + taskId + '/remove_reference_document?reference_document_id=' + referenceDocumentId + '&current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  createCompletionCriterion(completion_criterion, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    delete completion_criterion.toBeAdded;
    const task_id = completion_criterion.task_id;
    delete completion_criterion.task_id;
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/tasks/' + task_id + '/completion_criteria/?current_company=' + localStorage.current_company_id + (
        options && options.recordDescriptor ? '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor) : ''
      ),
      data: {
        event_metadatum: eventMetadatum,
        completion_criterion: completion_criterion,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  updateCompletionCriterion(completionCriterion, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const clonedStep = { ...completionCriterion };
    const task_id = clonedStep.task_id;
    delete clonedStep.task_id;
    delete clonedStep.deleted_at;
    delete clonedStep.event_histories;
    delete clonedStep.comments;
    delete clonedStep.attachments;  
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/tasks/' + task_id + '/completion_criteria/' + clonedStep.id + '?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        completion_criterion: clonedStep,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  copyCompletionCriterion(completionCriterion, changedData) {
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/tasks/' + completionCriterion.task_id + '/completion_criteria/' + completionCriterion.id + '/copy?&current_company=' + localStorage.current_company_id,
      data: {
        'completion_criterion': changedData,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      const errorMessage = error.response && error.response.data;
      if(errorMessage.instructions.length > 0 || errorMessage.name.length > 0){
        if(errorMessage.instructions.length > 0){
          DataModel.displayInfoErrorMessage('Instruction can\'t be blank', 4000, 2);
        }
        else{
          DataModel.displayInfoErrorMessage('Name can\'t be blank', 4000, 2);
        }
      }
      else{
        return { error: error };
      }
    });
  },
  reorderTasks(reorderPairs, build_id){
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/tasks/reorder_tasks?current_company=' + localStorage.current_company_id,
      data: {
        reorder_list: reorderPairs,
        build: build_id,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  reorderCompletionCriterion(task_id, reorderPairs){
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/tasks/' + task_id + '/reorder_completion_criteria?current_company=' + localStorage.current_company_id,
      data: {
        reorder_list: reorderPairs,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  rejectCompletionCriterion(completion_criterion, rejectionReason, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const task_id = completion_criterion.task_id;
    completion_criterion.not_applicable = false;
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/tasks/' + task_id + '/completion_criteria/' + completion_criterion.id + '/reject?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        rejection_reason: rejectionReason,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  reviewCompletionCriterion(completion_criterion, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const task_id = completion_criterion.task_id;
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/tasks/' + task_id + '/completion_criteria/' + completion_criterion.id + '/review?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        comment: completion_criterion.comment ? completion_criterion.comment : ' ',
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  approveCompletionCriterion(completion_criterion, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const task_id = completion_criterion.task_id;
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/tasks/' + task_id + '/completion_criteria/' + completion_criterion.id + '/approve?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        comment: completion_criterion.comment ? completion_criterion.comment : ' ',
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  revertCompletionCriterion(completion_criterion, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const task_id = completion_criterion.task_id;
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/tasks/' + task_id + '/completion_criteria/' + completion_criterion.id + '/revert?current_company=' + localStorage.current_company_id
        + (options && options.recordDescriptor ? '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor) : ''),
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  completeTask(task, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const task_id = task.id;
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/tasks/' + task_id + '/completion?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  reviewTask(task, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const task_id = task.id;
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/tasks/' + task_id + '/review?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  approveTask(task, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const task_id = task.id;
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/tasks/' + task_id + '/approve?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  markTaskNA(task, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const task_id = task.id;
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/tasks/' + task_id + '/mark_not_applicable?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  unmarkTaskNA(task, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const task_id = task.id;
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/tasks/' + task_id + '/unmark_not_applicable?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  completeCompletionCriterion(completion_criterion, completion, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const task_id = completion_criterion.task_id;
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/tasks/' + task_id + '/completion_criteria/' + completion_criterion.id + '/completion?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        completion_criterion: {
          completion: completion ? completion : (completion == false ? 'false': null),
        },
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  uploadCompletionCriterion(completion_criterion, attachment, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const task_id = completion_criterion.task_id;
    let url = process.env.REACT_APP_API + '/tasks/' + task_id + '/completion_criteria/' + completion_criterion.id + '/completion?current_company=' + localStorage.current_company_id;
    if (options && options.recordDescriptor){
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    let data = new FormData();
    data.append('completion_criterion[name]', attachment.name);
    data.append('completion_criterion[upload]', attachment.upload);
    data.append('completion_criterion[notes]', attachment.notes);
    data.append('completion_criterion[attachable_type]', attachment.attachable_type);
    data.append('completion_criterion[attachable_id]', attachment.attachable_id);
    data.append('event_metadatum', JSON.stringify(eventMetadatum));
    // if(attachment.s3_direct_post_url){
    //   data.append('file', attachment)
    //   let fields = attachment.s3_direct_post_url.fields
    //   for (var property in fields) {
    //     if (fields.hasOwnProperty(property)) {
    //       data.append(property, fields[property])
    //     }
    // }
      // url = attachment.s3_direct_post_url.url

    // }

    return axios({
      method: 'patch',
      url: url,
      data: data,
      timeout: 50000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteCompletionCriterion(completion_criterion, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    delete completion_criterion.toBeDeleted;
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/tasks/' + completion_criterion.task_id + '/completion_criteria/' + completion_criterion.id + '?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return { status: 'success' };
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  createFieldUser(task, field_user, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/tasks/' + task.id + '/field_user?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        user: { id: field_user.user ? field_user.user.id : field_user.id },
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  deleteFieldUser(task, field_user, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/tasks/' + task.id + '/remove_field_user?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        user: { id: field_user.user ? field_user.user.id : field_user.id },
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  createReviewer(task, reviewer, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/tasks/' + task.id + '/reviewer?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        user: { id: reviewer.user ? reviewer.user.id : reviewer.id },
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  deleteReviewer(task, reviewer, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/tasks/' + task.id + '/remove_reviewer?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        user: { id: reviewer.user ? reviewer.user.id : reviewer.id },
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  createApprover(task, approver, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/tasks/' + task.id + '/approver?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        user: { id: approver.user ? approver.user.id : approver.id },
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  deleteApprover(task, approver, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/tasks/' + task.id + '/remove_approver?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        user: { id: approver.user.id },
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  createNotify(task, notify, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    delete notify.toBeAdded;
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/tasks/' + task.id + '/notify?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        user: { id: notify.user ? notify.user.id :  notify.id },
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  deleteNotify(task, notify, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    delete notify.toBeDeleted;
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/tasks/' + task.id + '/remove_notify?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        user: { id: notify.user ? notify.user.id :  notify.id },
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  } };

export default helpers;

//postgres://u6369r2njfr3q8:p9a981676541c4e7e60c63b5febd18d879631c69b2243a4d4b105ca7d18167131@ec2-54-156-200-245.compute-1.amazonaws.com:5432/ddv7gb98k70cor



// WEBPACK FOOTER //
// ./src/services/tasksService.js